import {
    Box,
    Button,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import {
    Delete as DeleteIcon,
    Email as EmailIcon
} from '@mui/icons-material';

import { AccountInvitation } from '../../API';
import { MemberChip } from './MemberChip';
import { OwnerChip } from './OwnerChip';
import { TeamType } from '../../models';
import { useState } from 'react';
import { useTeamManagement } from './useTeamManagement';

export const PendingInvitationsTab = () => {
    const { invitations, removeInvitation, inviteUserToOrganization } = useTeamManagement();
    const [resendingId, setResendingId] = useState<string | null>(null);

    const handleResendInvitation = async (invitation: AccountInvitation) => {
        setResendingId(invitation.id);
        try {
            await inviteUserToOrganization.mutateAsync({ emails: [invitation.email], targetRole: invitation.role ?? TeamType.MEMBER });
        } finally {
            setResendingId(null);
        }
    };

    const onRemoveInvite = async (invitation: AccountInvitation) => {
        await removeInvitation.mutateAsync(invitation);
    };

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Sent Date</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {((invitations ?? []).length === 0) ? (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                <Typography color="text.secondary">
                                    No pending invitations
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        invitations?.map((invitation) => (
                            <TableRow key={invitation.id}>
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <EmailIcon sx={{ mr: 1 }} />
                                        {invitation.email}
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    {invitation.role === TeamType.OWNER ? (
                                        <OwnerChip />
                                    ) : (
                                        <MemberChip />
                                    )}
                                </TableCell>
                                <TableCell>{new Date(invitation.createdAt).toLocaleDateString()}</TableCell>
                                <TableCell align="right">
                                    <Button
                                        variant="outlined"
                                        startIcon={<EmailIcon />}
                                        onClick={() => handleResendInvitation(invitation)}
                                        sx={{ mr: 1 }}
                                        disabled={resendingId === invitation.id}
                                    >
                                        {resendingId === invitation.id ? 'Resending...' : 'Resend'}
                                    </Button>
                                    <IconButton
                                        onClick={() => onRemoveInvite(invitation)}
                                        color="error"
                                        size="small"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}; 